import Gdnav from "./Gdnav";
import Gdsph from "./Gdsph";
import Gdspm from "./Gdspm";
import Gdhangtet from "./Gdhangtet";
import Gdmebe from "./Gdmebe";
import Gddcn from "./Gddcn";
import Gdddm from "./Gdddm";
import Gdfooter from "./Gdfooter";

export default function Giadung() {
  return (
    <div>
      <Gdnav />
      <Gdsph />
      <Gdspm />
      <Gdhangtet />
      <Gdmebe />
      <Gddcn />
      <Gdddm />
      <Gdfooter />
    </div>
  );
}
